module.exports = __webpack_public_path__ + "media/music/1e7ed7b14b056ebd80f434143846fb4e.mp3";